import React, { useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import { useTheme } from "@material-ui/core/styles";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import MuiAutoComplete from "Components/MuiAutoComplete/MuiAutoComplete";
import Translator from "Languages/Utility/Translator";
import { useSetState } from "Helpers/Hooks";
import MuiButton from "Components/MuiButton/MuiButton";
import { read } from "Helpers/LocalStorage";
import ProjectService from "Services/http/endpoints/project/ProjectService";
import StatusHandler from "Helpers/StatusHandler";
import CustomerService from "Services/http/endpoints/customer/CustomerService";
import UntiBarService from "Services/http/endpoints/design/UntiBarService";
import showNotify from "Helpers/Notify";
import MuiSkeleton from "Components/MuiSkeleton/MuiSkeleton";
import { useDispatch, useSelector } from "react-redux";
import { getDesignUnitList } from "Stores/actions";
import { DESIGN_UNIT_LIST } from "Stores/actionTypes";
import { DialogActions } from "@material-ui/core";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useTranslation } from "react-i18next";
import * as Icons from "react-bootstrap-icons";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";

function CopyUnit() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const StypeU = read("StypeU");
  const UserC = read("UserC");
  const { selectedProject, unitListPagination, selectedUnitCount } =
    useSelector((state) => ({
      selectedProject: state.project.selectedProject,
      unitListPagination: state.design.unitListPagination,
      selectedUnitCount: state.design.selectedUnitCount,
    }));
  const [loading, setLoading] = useState(0);
  const [openDialog, setOpenDialog] = useState(false);
  const dispatch = useDispatch();

  const [controls, setControls] = useSetState({
    users: {
      type: "select",
      selectItems: [],
      value: "",
    },
    customers: {
      type: "select",
      selectItems: [],
      value: "",
    },
    projects: {
      type: "select",
      selectItems: [],
      value: "",
    },
  });

  const handleDialog = () => setOpenDialog(!openDialog);

  const onEnter = async () => {
    try {
      if ((StypeU === "1" || StypeU === "5") && UserC === "-") await getUsers();
      else await getCustomers();
    } catch (err) {
      console.error("[catch error]", err);
      handleDialog();
    }
  };

  const autoCompleteHandler = async (e, value) => {
    const controlName = e.target.id.split("-")[0];
    setControls({ [controlName]: { value: value } });
    if (controlName === "customers") {
      getProjects(
        value.value,
        (StypeU === "1" || StypeU === "5") && UserC === "-"
          ? controls.users.value.value
          : null,
      );
    }
    if (controlName === "users") {
      getCustomers(value.value);
    }
  };

  const getUsers = async () => {
    try {
      setLoading(1);
      const params = {
        Key: read("groupKey"),
        KeyUs: read("userKey"),
      };
      const responseUsers = await ProjectService.selectUserGroupCombo(params);
      let err = StatusHandler(responseUsers);
      if (!err.isFail) {
        const lists = responseUsers.data.Value;
        const items = getNormalize(lists, "Key", "DisplayName");
        setControls({
          users: { selectItems: items, value: items.length ? items[0] : "" },
        });
        setLoading(0);
        if (items.length) {
          await getCustomers(items[0].value);
        } else {
          setControls({
            customers: {
              selectItems: [],
              value: "",
            },
          });
        }
      }
    } catch (err) {
      setLoading(0);
      console.error("[catch error]", err);
      setControls({
        users: {
          selectItems: [],
          value: "",
        },
        customers: {
          selectItems: [],
          value: "",
        },
        projects: {
          selectItems: [],
          value: "",
        },
      });
    }
  };

  const getCustomers = async (KeyRequestUser = null) => {
    try {
      setLoading(2);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ...{
          KeyRequestUser,
        },
      };
      const responseCustomer = await CustomerService.getComboMoshtari(params);
      let err = StatusHandler(responseCustomer);
      if (!err.isFail) {
        const moshtariList = responseCustomer.data.Value;
        const items = getNormalize(moshtariList, "Id", "Name");
        setControls({
          customers: {
            selectItems: items,
            value: items.length ? items[0] : "",
          },
        });
        setLoading(0);
        if (items.length) {
          await getProjects(items[0].value);
        } else {
          setControls({
            projects: {
              selectItems: [],
              value: "",
            },
          });
        }
      }
    } catch (err) {
      setLoading(0);
      console.error("[catch error]", err);
      setControls({
        customers: {
          selectItems: [],
          value: "",
        },
        projects: {
          selectItems: [],
          value: "",
        },
      });
    }
  };

  const getProjects = async (IdCustomer = null, KeyRequestUser = null) => {
    try {
      setLoading(3);
      const params = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        ...{
          IdCustomer,
        },
        ...{
          KeyRequestUser,
        },
      };
      const response = await ProjectService.getAllProjectCustomerList(params);
      let err = StatusHandler(response);
      if (!err.isFail) {
        const projectList = response.data.Value;
        const items = getNormalize(projectList, "Id", "Name");
        setControls({
          projects: {
            selectItems: items,
            value: items.length ? items[0] : "",
          },
        });
      }
      setLoading(0);
    } catch (err) {
      setLoading(0);
      console.error("[catch error]", err);
      setControls({
        projects: {
          selectItems: [],
          value: "",
        },
      });
    }
  };

  const getNormalize = (data, value, label) => {
    return data.map((m) => {
      return {
        ...m,
        value: m[value],
        label: m[label],
      };
    });
  };

  const onFinish = async () => {
    const { projects } = controls;
    if (projects.value === "") return;
    try {
      setLoading(4);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        IdProject: projects.value.value,
        ProjectIdSelected: selectedProject.Id,
      };
      const response = await UntiBarService.CopyUnitAction(data);
      let err = StatusHandler(response);
      if (!err.isFail) {
        showNotify({
          text: t("wasCopiedSuccessfully"),
          customClass: "success",
        });
        handleDialog();
        if (selectedProject.Id === projects.value.value) {
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdProject: selectedProject.Id,
            Limit: unitListPagination.Limit,
            Page: 1,
          };
          const response = await dispatch(getDesignUnitList(params));
          dispatch({
            type: DESIGN_UNIT_LIST,
            unitList: response.Value,
            unitListPagination: response.Pagination,
          });
        }
      }
      setLoading(0);
    } catch (err) {
      setLoading(0);
      console.error("[catch error]", err);
    }
  };

  return (
    <>
      <BackDropLoading loading={loading === 4} />
      <MuiIconButton
        className="warning-fill"
        icon={<Icons.Copy size={17} />}
        title={<Translator id="copyUnit" />}
        onClick={handleDialog}
        disabled={selectedUnitCount === 0}
      />
      <Dialog
        dir={direction}
        open={openDialog}
        onClose={handleDialog}
        onEnter={onEnter}
        fullWidth
        maxWidth="xs"
      >
        <div className="dialogHeader">
          <p>
            <Translator id="copyUnit" noSpan />
          </p>
        </div>
        <DialogContent>
          <Grid container spacing={2}>
            {(StypeU === "1" || StypeU === "5") && UserC === "-" && (
              <Grid item xs={12}>
                {loading === 1 ? (
                  <MuiSkeleton xs={12} number={1} />
                ) : (
                  <MuiAutoComplete
                    autoSelect={true}
                    options={controls.users.selectItems}
                    label={<Translator id={"users"} />}
                    value={controls.users.value}
                    id={"users"}
                    onChange={autoCompleteHandler}
                  />
                )}
              </Grid>
            )}
            <Grid item xs={12}>
              {loading === 1 || loading === 2 ? (
                <MuiSkeleton xs={12} number={1} />
              ) : (
                <MuiAutoComplete
                  autoSelect={true}
                  options={controls.customers.selectItems}
                  label={<Translator id={"customers"} />}
                  value={controls.customers.value}
                  id={"customers"}
                  onChange={autoCompleteHandler}
                />
              )}
            </Grid>
            <Grid item xs={12}>
              {loading === 1 || loading === 2 || loading === 3 ? (
                <MuiSkeleton xs={12} number={1} />
              ) : (
                <MuiAutoComplete
                  disabled={!controls.customers.value.value}
                  autoSelect={true}
                  options={controls.projects.selectItems}
                  label={<Translator id={"projects"} />}
                  value={controls.projects.value}
                  id={"projects"}
                  onChange={autoCompleteHandler}
                />
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <MuiButton
            color="primary"
            onClick={onFinish}
            disabled={loading !== 0 || controls.projects.value === ""}
            loading={loading === 4}
            title={<Translator id="button_save" />}
          />
          <MuiButton
            onClick={handleDialog}
            title={<Translator id="enseraf" />}
          />
        </DialogActions>
      </Dialog>
    </>
  );
}

export default CopyUnit;
